import { axiosBeelineRequest } from '@beef/utils';
import { CATALOG_PAGE_ENDPOINTS, CONTENT_KEYS } from "../constants";
export var fetchApiTexts = function fetchApiTexts() {
  return axiosBeelineRequest({
    url: "".concat(CATALOG_PAGE_ENDPOINTS.fetchApiTexts, "?key=").concat(CONTENT_KEYS.join(','))
  }).then(function (data) {
    return data;
  });
};